import * as ScheduleActions from './schedule.actions';

export default ScheduleActions;
